import { targetParams, type ClientTarget } from '@features/clients';
import { apiRequest } from '@lib/api';

import {
    ActivationDetail,
    ActivationListResponse,
    type ActivationMuseum,
} from '../schemas/activation';

/**
 * The Feature Activation read API, one function per route.
 *
 * Aimed like the clients API — `?env=` and, for an ephemeral slot, `&slot=` —
 * because the museums, their flags and the hub all live in one deployment, and
 * a request that does not say which one would be answered by whichever the
 * server defaulted to.
 */

function query(target: ClientTarget): string {
    return new URLSearchParams(targetParams(target)).toString();
}

export async function listActivationMuseums(
    target: ClientTarget,
    signal?: AbortSignal,
): Promise<ActivationMuseum[]> {
    const { museums } = await apiRequest(
        `/activation-tracking?${query(target)}`,
        ActivationListResponse,
        { signal },
    );
    return museums;
}

/** A 404 is an answer: the tenant does not have Feature activation turned on. */
export function getActivationMuseum(
    target: ClientTarget,
    tenantId: string,
    signal?: AbortSignal,
): Promise<ActivationDetail> {
    return apiRequest(
        `/activation-tracking/${encodeURIComponent(tenantId)}?${query(target)}`,
        ActivationDetail,
        { signal },
    );
}
